import React from "react";
import { ReactComponent as GreenDotSVG } from "go-list/core/images/statuses/active.svg";
import { ReactComponent as RedDotSVG } from "go-list/core/images/statuses/disabled.svg";
import { AvailableSubscriptionContentsApi } from "../../../../../../../../services/Api/Subscription/subscriptionTypes";
import SubscriptionSummaryPreviewSingleSubscriptionDetailsAddons from "./SubscriptionSummaryPreviewSingleSubscriptionDetailsAddons";
import { renderSubscriptionDefaultMoney, renderSubscriptionMoney } from "./utils";

interface Props {
	allSubscriptions: any[];
	renderOnlyCurrentSubscription?: boolean;
	renderOnlyPreviousSubscription?: boolean;
	config: AvailableSubscriptionContentsApi;
}

const SubscriptionSummaryPreviewSubscriptions = ({
	allSubscriptions,
	renderOnlyPreviousSubscription,
	renderOnlyCurrentSubscription,
	config,
}: Props) => {
	const renderAll = !renderOnlyPreviousSubscription && !renderOnlyCurrentSubscription;

	const drawContent = (allSubscription: any, isCancelledOriginal: boolean, isCancelledEstimate: boolean) => {
		if (renderAll) {
			return (
				<React.Fragment key={`${allSubscription.familyName}`}>
					<div className={"row no-gutters"}>
						<div
							className={`col subscription-summary-list-item original-app${
								!allSubscription.original ? " cancelled diff-subscription worse-subscription" : ""
							}`}
						>
							<h6>
								{isCancelledOriginal && <RedDotSVG className="me-1" />}
								{isCancelledEstimate && <GreenDotSVG className="me-1" />}
								<span>{allSubscription.familyName}</span>
							</h6>
						</div>
						<div
							className={`col text-end subscription-summary-list-item original-price${
								!allSubscription.original ? " cancelled diff-subscription worse-subscription" : ""
							}`}
						>
							<div className={"subscription-summary-price"}>
								{allSubscription.original && (
									<>
										<h6 className="mb-0">
											{renderSubscriptionDefaultMoney(allSubscription.original)}
										</h6>
										<p className="mb-0">
											{renderSubscriptionDefaultMoney(allSubscription.original)}
										</p>
									</>
								)}
							</div>
						</div>
						<div
							className={`col subscription-summary-list-item compare-app${
								!allSubscription.estimate ? " cancelled diff-subscription worse-subscription" : ""
							}`}
						>
							<h6>
								{isCancelledEstimate && <RedDotSVG className="me-1" />}
								{isCancelledOriginal && <GreenDotSVG className="me-1" />}
								<span>{allSubscription.familyName}</span>
							</h6>
						</div>
						<div
							className={`col text-end subscription-summary-list-item compare-price${
								!allSubscription.estimate ? " cancelled diff-subscription worse-subscription" : ""
							}`}
						>
							<div className={"subscription-summary-price"}>
								{allSubscription.estimate && (
									<>
										<h6 className="mb-0">
											{renderSubscriptionDefaultMoney(allSubscription.estimate)}
										</h6>
										<p className="mb-0">
											{renderSubscriptionDefaultMoney(allSubscription.estimate)}
										</p>
									</>
								)}
							</div>
						</div>
					</div>
					{(() => {
						const differentPlan =
							!allSubscription.original ||
							!allSubscription.estimate ||
							allSubscription.original.plan_id !== allSubscription.estimate.plan_id ||
							allSubscription.original.billing_period !== allSubscription.estimate.billing_period;
						let originalClass = "";
						if (differentPlan) originalClass += " diff-subscription";
						if (isCancelledOriginal) originalClass += " cancelled";
						const isBetterEstimate = !!allSubscription.estimate;
						originalClass += " worse-subscription";
						let estimateClass = "";
						if (differentPlan) estimateClass += " diff-subscription";
						if (isCancelledEstimate) estimateClass += " cancelled";
						if (!isBetterEstimate && differentPlan) estimateClass += " worse-subscription";
						const planOriginalName = allSubscription.original
							? allSubscription.original.name
							: allSubscription.estimate.name;
						const planEstimateName = allSubscription.estimate
							? allSubscription.estimate.name
							: allSubscription.original.name;
						return (
							<div className={"row no-gutters"}>
								<div
									className={`col subscription-summary-list-item subscription-summary-list-item-addon original-app${originalClass}`}
								>
									<span
										className={`${
											differentPlan ? (isBetterEstimate ? "text-danger" : "text-success") : ""
										}`}
									>
										Pakiet {planOriginalName}
									</span>
								</div>
								<div
									className={`col text-end subscription-summary-list-item subscription-summary-list-item-addon original-price${originalClass}`}
								>
									<div className={"subscription-summary-price text-muted"}>
										{allSubscription.original &&
											renderSubscriptionMoney(
												allSubscription.original.billing_period,
												allSubscription.original.subscription_money
											)}
									</div>
								</div>
								<div
									className={`col subscription-summary-list-item subscription-summary-list-item-addon compare-app${estimateClass}`}
								>
									<span
										className={`${
											differentPlan ? (!isBetterEstimate ? "text-danger" : "text-success") : ""
										}`}
									>
										Pakiet {planEstimateName}
									</span>
								</div>
								<div
									className={`col text-end subscription-summary-list-item subscription-summary-list-item-addon compare-price${estimateClass}`}
								>
									<div className={"subscription-summary-price text-muted"}>
										{allSubscription.estimate &&
											renderSubscriptionMoney(
												allSubscription.estimate.billing_period,
												allSubscription.estimate.subscription_money
											)}
									</div>
								</div>
							</div>
						);
					})()}
					<SubscriptionSummaryPreviewSingleSubscriptionDetailsAddons
						subscription={allSubscription}
						renderAll={renderAll}
						renderOnlyPreviousSubscription={renderOnlyPreviousSubscription}
						renderOnlyCurrentSubscription={renderOnlyCurrentSubscription}
						config={config}
					/>
					<div className={"row no-gutters"}>
						<div className={"col original-sub"}>
							<div className={"subscription-divider"}></div>
						</div>
						<div className={"col compare-sub"}>
							<div className={"subscription-divider"}></div>
						</div>
					</div>
				</React.Fragment>
			);
		}

		if (renderOnlyPreviousSubscription) {
			return (
				<React.Fragment key={`${allSubscription.familyName}`}>
					<div className={"row no-gutters"}>
						<div
							className={`col subscription-summary-list-item original-app${
								!allSubscription.original ? " cancelled diff-subscription worse-subscription" : ""
							}`}
						>
							<h6>
								{isCancelledOriginal && <RedDotSVG className="me-1" />}
								{isCancelledEstimate && <GreenDotSVG className="me-1" />}
								<span>{allSubscription.familyName}</span>
							</h6>
						</div>
						<div
							className={`col text-end subscription-summary-list-item original-price${
								!allSubscription.original ? " cancelled diff-subscription worse-subscription" : ""
							}`}
						>
							<div className={"subscription-summary-price"}>
								{allSubscription.original && (
									<>
										<h6 className="mb-0">
											{renderSubscriptionDefaultMoney(allSubscription.original)}
										</h6>
										<p className="mb-0">
											{renderSubscriptionDefaultMoney(allSubscription.original)}
										</p>
									</>
								)}
							</div>
						</div>
					</div>
					{(() => {
						const differentPlan =
							!allSubscription.original ||
							!allSubscription.estimate ||
							allSubscription.original.plan_id !== allSubscription.estimate.plan_id ||
							allSubscription.original.billing_period !== allSubscription.estimate.billing_period;
						let originalClass = "";
						if (differentPlan) originalClass += " diff-subscription";
						if (isCancelledOriginal) originalClass += " cancelled";
						const isBetterEstimate = !!allSubscription.estimate;
						originalClass += " worse-subscription";
						const planOriginalName = allSubscription.original
							? allSubscription.original.name
							: allSubscription.estimate.name;
						return (
							<div className={"row no-gutters"}>
								<div
									className={`col subscription-summary-list-item subscription-summary-list-item-addon original-app${originalClass}`}
								>
									<span
										className={`${
											differentPlan ? (isBetterEstimate ? "text-danger" : "text-success") : ""
										}`}
									>
										Pakiet {planOriginalName}
									</span>
								</div>
								<div
									className={`col text-end subscription-summary-list-item subscription-summary-list-item-addon original-price${originalClass}`}
								>
									<div className={"subscription-summary-price text-muted"}>
										{allSubscription.original &&
											renderSubscriptionMoney(
												allSubscription.original.billing_period,
												allSubscription.original.subscription_money
											)}
									</div>
								</div>
							</div>
						);
					})()}
					<SubscriptionSummaryPreviewSingleSubscriptionDetailsAddons
						subscription={allSubscription}
						renderAll={renderAll}
						renderOnlyPreviousSubscription={renderOnlyPreviousSubscription}
						renderOnlyCurrentSubscription={renderOnlyCurrentSubscription}
						config={config}
					/>
					<div className={"row no-gutters"}>
						<div className={"col original-sub"}>
							<div className={"subscription-divider"}></div>
						</div>
					</div>
				</React.Fragment>
			);
		}

		if (renderOnlyCurrentSubscription) {
			return (
				<React.Fragment key={`${allSubscription.familyName}`}>
					<div className={"row no-gutters"}>
						<div
							className={`col subscription-summary-list-item compare-app${
								!allSubscription.estimate ? " cancelled diff-subscription worse-subscription" : ""
							}`}
						>
							<h6>
								{isCancelledEstimate && <RedDotSVG className="me-1" />}
								{isCancelledOriginal && <GreenDotSVG className="me-1" />}
								<span>{allSubscription.familyName}</span>
							</h6>
						</div>
						<div
							className={`col text-end subscription-summary-list-item compare-price${
								!allSubscription.estimate ? " cancelled diff-subscription worse-subscription" : ""
							}`}
						>
							<div className={"subscription-summary-price"}>
								{allSubscription.estimate && (
									<>
										<h6 className="mb-0">
											{renderSubscriptionDefaultMoney(allSubscription.estimate)}
										</h6>
										<p className="mb-0">
											{renderSubscriptionDefaultMoney(allSubscription.estimate)}
										</p>
									</>
								)}
							</div>
						</div>
					</div>
					{(() => {
						const differentPlan =
							!allSubscription.original ||
							!allSubscription.estimate ||
							allSubscription.original.plan_id !== allSubscription.estimate.plan_id ||
							allSubscription.original.billing_period !== allSubscription.estimate.billing_period;
						const isBetterEstimate = !!allSubscription.estimate;
						let estimateClass = "";
						if (differentPlan) estimateClass += " diff-subscription";
						if (isCancelledEstimate) estimateClass += " cancelled";
						if (!isBetterEstimate && differentPlan) estimateClass += " worse-subscription";
						const planEstimateName = allSubscription.estimate
							? allSubscription.estimate.name
							: allSubscription.original.name;
						return (
							<div className={"row no-gutters"}>
								<div
									className={`col subscription-summary-list-item subscription-summary-list-item-addon compare-app${estimateClass}`}
								>
									<span
										className={`${
											differentPlan ? (!isBetterEstimate ? "text-danger" : "text-success") : ""
										}`}
									>
										Pakiet {planEstimateName}
									</span>
								</div>
								<div
									className={`col text-end subscription-summary-list-item subscription-summary-list-item-addon compare-price${estimateClass}`}
								>
									<div className={"subscription-summary-price text-muted"}>
										{allSubscription.estimate &&
											renderSubscriptionMoney(
												allSubscription.estimate.billing_period,
												allSubscription.estimate.subscription_money
											)}
									</div>
								</div>
							</div>
						);
					})()}
					<SubscriptionSummaryPreviewSingleSubscriptionDetailsAddons
						subscription={allSubscription}
						renderAll={renderAll}
						renderOnlyPreviousSubscription={renderOnlyPreviousSubscription}
						renderOnlyCurrentSubscription={renderOnlyCurrentSubscription}
						config={config}
					/>
					<div className={"row no-gutters"}>
						<div className={"col compare-sub"}>
							<div className={"subscription-divider"}></div>
						</div>
					</div>
				</React.Fragment>
			);
		}
	};

	return (
		<>
			{allSubscriptions.map((allSubscription) => {
				const differentSubscription = !allSubscription.original || !allSubscription.estimate;
				const isCancelledOriginal = differentSubscription && !allSubscription.original;
				const isCancelledEstimate = differentSubscription && !allSubscription.estimate;

				return drawContent(allSubscription, isCancelledOriginal, isCancelledEstimate);
			})}
		</>
	);
};

export default SubscriptionSummaryPreviewSubscriptions;
